module.exports = __webpack_public_path__ + "img/scheme-top1.54ed3995.png";